export const SET_CONTRACT_TEMPLATES = "SET_CONTRACT_TEMPLATES";
export const SET_CURRENT_TEMPLATE = "SET_CURRENT_TEMPLATE";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const SET_LOADING = "SET_LOADING";
